import * as React from 'react';

import { ModalFrame, ModalFrameFooter, ModalFrameMessage } from 'components/modal';
import ActionButton from 'components/buttons/action-button/ActionButton';

import { __t, applyTranslations } from 'utils/language';
import { QUERY, YOUTUBE } from 'modules/insights/sov/utils/sov';
import { MULTI, convertLocalQueryToEndpoint } from 'modules/insights/sov/utils/queries/sov-queries';

import type {
  SOVGeneralActionType,
  SOVGeneralProps,
  SOVGeneralSectionType,
  SOVQueryLocal,
  SOVReport,
  SOVReportType
} from 'modules/insights/sov/types';

applyTranslations(require('locales/common/collabary-common.i18n.json'));

type Props = {
  report: SOVReport,
  reportType: SOVReportType,
  query: SOVQueryLocal,
  sectionType: SOVGeneralSectionType,
  actionType: SOVGeneralActionType,
  title: string,
  message: string,
  labels: SOVGeneralProps,
  onAction: (a: Partial<SOVGeneralProps>) => void,
  onCloseModal: () => void
};

const COLLABARY_MSG_KEY = 'collabary_common';

class SOVModalGeneric extends React.PureComponent<Props> {
  handleDuplicateReport(): void {
    const { report, reportType, onAction } = this.props;

    onAction({ reportId: report.id, reportType });
  }

  handleDeleteReport(): void {
    const { report, reportType, onAction } = this.props;
    const reportId = report.id;

    onAction({ reportId, reportType });
  }

  handleActionReport(): void {
    const { actionType, onCloseModal } = this.props;

    if (actionType === 'duplicate') {
      this.handleDuplicateReport();
    }

    if (actionType === 'delete') {
      this.handleDeleteReport();
    }

    onCloseModal();
  }

  handleDuplicateQuery(): void {
    const { query, reportType, onAction } = this.props;
    const endpointQuery = reportType === YOUTUBE
      ? query
      : convertLocalQueryToEndpoint(query);

    onAction({
      query: {
        ...endpointQuery,
        id: endpointQuery.id,
        isMulti: endpointQuery.type === MULTI
      }
    });
  }

  handleDeleteQuery(): void {
    const { report, reportType, query, onAction } = this.props;
    const endpointQuery = reportType === YOUTUBE
      ? query
      : convertLocalQueryToEndpoint(query);

    onAction({
      reportId: report.id,
      queryId: endpointQuery.id,
      isMulti: endpointQuery.type === MULTI
    });
  }

  handleActionQuery(): void {
    const { actionType, onCloseModal } = this.props;

    if (actionType === 'duplicate') {
      this.handleDuplicateQuery();
    }

    if (actionType === 'delete') {
      this.handleDeleteQuery();
    }

    onCloseModal();
  }

  handleAction = (): void => {
    const { sectionType } = this.props;

    if (sectionType === QUERY) {
      this.handleActionQuery();
      return;
    }

    this.handleActionReport();
  };

  render(): React.ReactNode {
    const { title, message, labels, onCloseModal } = this.props;

    return (
      <ModalFrame title={title}>
        <ModalFrameMessage
          message={message}
        />
        <ModalFrameFooter>
          <ActionButton
            color="tertiary"
            onClick={onCloseModal}
          >
            {__t(`${COLLABARY_MSG_KEY}.action_button.cancel`)}
          </ActionButton>
          <ActionButton onClick={this.handleAction}>
            {labels.actionButton}
          </ActionButton>
        </ModalFrameFooter>
      </ModalFrame>
    );
  }
}

export default SOVModalGeneric;
